import { createSelector } from '@reduxjs/toolkit';
import { PlenumDataInside, PlenumDataSupply } from 'application/shared/PlenumDataSupply';
import { selectProjectState } from 'projectRedux/store';
import { eppDataComponentAdapter } from '../adapters/eppDataComponentAdapter';

export const {
  selectAll: selectAllEppDataComponents,
  selectById: selectEppDataComponentById,
  selectEntities: selectEppDataComponentEntities,
} = eppDataComponentAdapter.getSelectors((state) => selectProjectState(state).eppdatacomponents);

export const makeSelectEppDataComponentsByDirection = () => {
  return createSelector(
    (state: any, supply: PlenumDataSupply, inside: PlenumDataInside, plenumIndex: number) => supply,
    (state: any, supply: PlenumDataSupply, inside: PlenumDataInside, plenumIndex: number) => inside,
    (state: any, supply: PlenumDataSupply, inside: PlenumDataInside, plenumIndex: number) => plenumIndex,
    // First, pass one or more "input selector" functions:
    selectAllEppDataComponents,
    // Then, an "output selector" that receives all the input results as arguments
    // and returns a final result value
    (supply, inside, plenumIndex, eppdatacomponents) =>
      eppdatacomponents.filter(
        (eppdatacomponent) =>
          eppdatacomponent.supply === supply &&
          eppdatacomponent.inside === inside &&
          eppdatacomponent.plenumIndex === plenumIndex
      )
  );
};
